// Bridge: re-export the project details implementation from `src/projects/pages`
import ProjectDetails from "../projects/pages/ProjectDetails";

export default ProjectDetails;
